import styles from "./headerTitle.module.css";

const HeaderTitle = ({ title, subtitle, children, icon }) => {
  return (
    <div className={styles.titleContainer}>
      <div className={styles.titleBlock}>
        {icon && <img src={icon} alt="Ícone" className={styles.icon} />}
        <div>
          <h1>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>

      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
};

export default HeaderTitle;
